<template>
    <div>
        <div class="about" :class="{ active: animate }">
      <div class="aboutHeader">
        <img
          src="../../../../assets/oracleConsulting/oracleConsulting.jpg"
          alt="aboutHeader"
          id="aboutHeaderImage"
        />
      </div>
      <div class="top-left">
        <h1 class="drop-from-top">
          Oracle <br />
          Consulting
        </h1>
        <p class="drop-from-bottom">
          Transforming Enterprises with Oracle <br />
          Consulting Excellence
        </p>
      </div>
    </div>
    </div>
</template>

<script src="./first.js"></script>
<style src="./first.css"></style>